<div class="main">
  <spb-header></spb-header>
  <div [style.flex]="1"></div>
  <div class="router">
    <router-outlet></router-outlet>
  </div>
  <div [style.flex]="4"></div>
  <spb-footer
      (logoutUser)="configService.reset()"
      [copyrightYears]="copyrightYears"
      [license]="true"
      [token]="configService.accessToken()"
      [version]="version"
  ></spb-footer>
</div>